import { Layout } from 'antd'
import React from 'react'
import HomeBody from '../../components/UnAuthorized/HomeBody'

const HomePage = () => {
    return (
        <Layout>
            <Layout.Content>
                <HomeBody/>
            </Layout.Content>
        </Layout>
    )
}

export default HomePage
